export enum ArenaSignApi {
  DocuSign = 0,
  Scrive = 1
}
